import { ProcessMessage } from './useProcessMessage'
import { DriveItem } from '@microsoft/microsoft-graph-types'
import useEmailFilingHandler from '../email/useEmailFilingHandler'
import { QueueStatus } from '../useQueueStateHandler'

/**
 * Messages originating from the Inboxer in order to update a EmailFilingToast.
 */
export type EmailFiledNotificationData = {
    messageId: string // The original service bus message ID.
    driveItem: DriveItem
}

export type EmailFiledNotification = ProcessMessage<EmailFiledNotificationData>

export default function useProcessEmailFiledNotification() {
    const handler = useEmailFilingHandler()
    return (notification: EmailFiledNotification) => {
        handler.transition(notification.data.messageId, QueueStatus.Finished)
    }
}
